import React from "react";
import ImageUploader from "react-images-upload";

const ImageUploaderField = ({
  withIcon = true,
  buttonText,
  label,
  name,
  onChange,
  labelStyles,
  singleImage = true,
  withPreview = true,
}) => {
  return (
    <div className="form-group">
      <label style={{ ...labelStyles }}>{label}</label>
      <div className="input-group col-xs-12">
        <ImageUploader
          withIcon={withIcon}
          buttonText={buttonText}
          onChange={onChange}
          name={name}
          imgExtension={[".jpg", ".gif", ".png", ".gif"]}
          maxFileSize={5242880}
          singleImage={singleImage}
          withPreview={withPreview}
        />
      </div>
    </div>
  );
};

export default ImageUploaderField;
